"use client"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="relative flex items-center justify-center min-h-screen w-full overflow-hidden bg-background">
        {/* Animated Background - Beyond Agency Style */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full bg-[#101010]">
            {/* Grid pattern */}
            <div className="absolute inset-0 opacity-20">
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage:
                    "linear-gradient(#5F72FF22 1px, transparent 1px), linear-gradient(90deg, #5F72FF22 1px, transparent 1px)",
                  backgroundSize: "40px 40px",
                }}
              ></div>
            </div>

            {/* Animated gradient blobs */}
            <motion.div
              initial={{ scale: 0.8, opacity: 0.3 }}
              animate={{
                scale: [0.8, 1.2, 0.9, 1.1, 0.8],
                opacity: [0.3, 0.4, 0.2, 0.5, 0.3],
                x: ["-10%", "5%", "0%", "-5%", "-10%"],
                y: ["5%", "-5%", "10%", "0%", "5%"],
              }}
              transition={{ duration: 20, repeat: Number.POSITIVE_INFINITY, repeatType: "loop" }}
              className="absolute top-1/4 left-1/4 w-[40vw] h-[40vw] rounded-full bg-accent opacity-20 blur-[100px]"
            />
            <motion.div
              initial={{ scale: 0.9, opacity: 0.2 }}
              animate={{
                scale: [0.9, 1.1, 0.8, 1.2, 0.9],
                opacity: [0.2, 0.3, 0.4, 0.2, 0.2],
                x: ["10%", "-5%", "15%", "0%", "10%"],
                y: ["-5%", "10%", "0%", "5%", "-5%"],
              }}
              transition={{ duration: 25, repeat: Number.POSITIVE_INFINITY, repeatType: "loop", delay: 1 }}
              className="absolute bottom-1/4 right-1/4 w-[50vw] h-[50vw] rounded-full bg-accent2 opacity-20 blur-[120px]"
            />
            <motion.div
              initial={{ scale: 0.7, opacity: 0.2 }}
              animate={{
                scale: [0.7, 1.0, 0.8, 0.9, 0.7],
                opacity: [0.2, 0.3, 0.1, 0.3, 0.2],
                x: ["-5%", "10%", "-10%", "5%", "-5%"],
                y: ["0%", "5%", "-5%", "-10%", "0%"],
              }}
              transition={{ duration: 30, repeat: Number.POSITIVE_INFINITY, repeatType: "loop", delay: 2 }}
              className="absolute top-1/3 right-1/3 w-[45vw] h-[45vw] rounded-full bg-highlight opacity-10 blur-[150px]"
            />
          </div>
        </div>

        <div className="relative z-10 flex flex-col items-center text-center px-4 max-w-5xl mx-auto">
          <div className="overflow-hidden">
            <motion.h1
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: [0.165, 0.84, 0.44, 1] }}
              className="text-5xl md:text-7xl font-bold mb-8 leading-tight text-white drop-shadow-lg font-futuristic tracking-tight"
            >
              <span className="text-white">Revolutionize Your</span>{" "}
              <span className="bg-gradient-to-r from-accent via-white to-accent2 bg-clip-text text-transparent animate-gradient-glow font-extrabold">
                Business With <span className="text-highlight animate-glow">AI</span>
              </span>
            </motion.h1>
          </div>

          <div className="overflow-hidden mb-10">
            <motion.p
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.3, ease: [0.165, 0.84, 0.44, 1] }}
              className="text-xl md:text-2xl text-white mb-2 max-w-3xl mx-auto font-normal"
            >
              Our AI-powered solutions transform how you interact with customers,
            </motion.p>
            <motion.p
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4, ease: [0.165, 0.84, 0.44, 1] }}
              className="text-xl md:text-2xl text-white mb-10 max-w-3xl mx-auto font-normal"
            >
              streamline operations, and drive business growth.
            </motion.p>
          </div>

          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6, ease: [0.165, 0.84, 0.44, 1] }}
            className="flex flex-wrap gap-6 justify-center"
          >
            <Link
              to="/services"
              className="px-8 py-4 rounded-full font-bold text-lg bg-gradient-to-r from-highlight to-accent2 text-white shadow-xl hover:scale-105 hover:shadow-2xl transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-accent2/40 border-2 border-transparent animate-glow-btn-strong"
            >
              Explore Solutions
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 rounded-full font-bold text-lg border-2 border-highlight text-white bg-background backdrop-blur-md hover:bg-highlight hover:text-white transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-highlight/40 shadow-xl hover:shadow-highlight/30"
            >
              Contact Us
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Trusted By Section */}
      {/* <section className="py-12 bg-white dark:bg-gray-800">
{{ ... }}
        <div className="container-custom">
          <p className="text-center text-gray-500 mb-8">Trusted by leading companies</p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center justify-items-center opacity-70">
            {['Amazon', 'Microsoft', 'Google', 'Shopify', 'Airbnb', 'Uber'].map((company, index) => (
              <motion.div
                key={company}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-xl font-bold text-gray-400"
              >
                {company}
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Features Section */}
      <section className="py-32 relative overflow-hidden bg-background">
        {/* Background Elements */}
        <div className="absolute top-40 left-10 w-72 h-72 rounded-full bg-accent opacity-10 blur-3xl"></div>
        <div className="absolute bottom-40 right-10 w-80 h-80 rounded-full bg-accent2 opacity-10 blur-3xl"></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-20">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-bold text-white mb-6 font-futuristic"
            >
              <span className="bg-gradient-to-r from-accent to-accent2 bg-clip-text text-transparent">AI-Powered</span>{" "}
              Solutions
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl text-white max-w-3xl mx-auto"
            >
              Transform how you interact with customers, streamline operations, and drive business growth
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {[
              {
                title: "Enhanced Customer Communication",
                description: "AI-powered responses that deliver precise, timely information with minimal manual input.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    />
                  </svg>
                ),
              },
              {
                title: "Data-Driven Insights",
                description:
                  "Analyze customer interactions and buying patterns to identify trends and improve service strategies.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                ),
              },
              {
                title: "Improved Customer Retention",
                description: "Personalized experiences that build loyalty and reduce customer churn.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                ),
              },
              {
                title: "Streamlined Workflows",
                description: "Automate repetitive tasks to free up your team for high-value activities.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                ),
              },
              {
                title: "Intelligent Agentic Workflows",
                description: "Advanced AI agents that handle complex customer service scenarios autonomously.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                ),
              },
              {
                title: "Increased Productivity",
                description: "Boost team efficiency with AI tools that simplify complex processes.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                ),
              },
              {
                title: "Intelligent Marketing",
                description: "Identify cross-selling opportunities for existing customers to maximize lifetime value.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                    />
                  </svg>
                ),
              },
              {
                title: "Seamless Integration",
                description:
                  "Connect our AI agents with your existing CRM and ERP systems for unified business operations.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                    />
                  </svg>
                ),
              },
              {
                title: "Sales Optimization",
                description:
                  "Reduce non-selling activities and improve account management, allowing focus on new business growth.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                ),
              },
            ].map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.15 }}
                whileHover={{ y: -15, scale: 1.03, transition: { duration: 0.3 } }}
                className="backdrop-blur-xl bg-white/15 border-2 border-white/30 p-8 rounded-2xl hover:border-accent/70 transition-all duration-300 group shadow-xl shadow-accent/10 hover:shadow-accent/30"
              >
                <motion.div
                  className="mb-6 text-white group-hover:text-highlight transition-colors duration-300"
                  whileHover={{ rotate: [0, -10, 10, -5, 0], transition: { duration: 0.5 } }}
                >
                  <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br from-accent to-accent2 border-2 border-white/50 group-hover:border-highlight/50 transition-all duration-300 shadow-lg shadow-accent/30">
                    {feature.icon}
                  </div>
                </motion.div>
                <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-highlight transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-white group-hover:text-white transition-colors duration-300 font-medium">
                  {feature.description}
                </p>
                <div className="w-0 group-hover:w-full h-1 bg-gradient-to-r from-accent to-highlight mt-6 transition-all duration-500 rounded-full"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 relative overflow-hidden">
        {/* Gradient Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-accent/30 to-accent2/30 opacity-30"></div>

        {/* Animated Orbs */}
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-accent opacity-20 blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 rounded-full bg-accent2 opacity-20 blur-3xl animate-pulse-slower"></div>

        <div className="container-custom relative z-10">
          <div className="backdrop-blur-lg bg-background/80 border border-white/20 rounded-3xl p-12 md:p-16 max-w-4xl mx-auto">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl md:text-5xl font-bold mb-8 text-white text-center font-futuristic"
            >
              Ready to{" "}
              <span className="bg-gradient-to-r from-accent to-highlight bg-clip-text text-transparent">Transform</span>{" "}
              Your Business?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl mb-10 text-white text-center max-w-2xl mx-auto"
            >
              Join the growing number of businesses that are revolutionizing their operations with AlfasTech's AI
              solutions.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="flex justify-center"
            >
              <Link
                to="/contact"
                className="px-10 py-5 rounded-full font-semibold text-lg bg-gradient-to-r from-accent to-accent2 shadow-lg hover:shadow-accent/50 hover:scale-105 transition-all duration-300 text-white group relative overflow-hidden border-2 border-white/20"
              >
                <span className="relative z-10">Get Started Today</span>
                <span className="absolute inset-0 bg-gradient-to-r from-highlight to-accent2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Industries We Serve Section */}
      <section className="py-32 bg-background relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-accent opacity-5 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-highlight opacity-5 blur-3xl"></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-20">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-bold text-white mb-6 font-futuristic"
            >
              Industries{" "}
              <span className="bg-gradient-to-r from-accent2 to-highlight bg-clip-text text-transparent">We Serve</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl text-white max-w-3xl mx-auto"
            >
              Our AI solutions are tailored to meet the unique needs of various industries
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {[
              {
                title: "E-commerce",
                description:
                  "Streamline customer support for online stores with AI-powered solutions for WooCommerce, Shopify, and Magento.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                    />
                  </svg>
                ),
              },
              {
                title: "Professional Services",
                description:
                  "We provide expert consulting services to help businesses integrate state-of-the-art AI and machine learning technologies, driving innovation, efficiency, and competitive advantage.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                ),
              },
              {
                title: "Manufacturing",
                description:
                  "Empower businesses to make smarter, faster decisions by unifying and structuring data across ERP, CRM, and HRM systems—while providing intelligent tools that drive decision-making success.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 17a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2m-2 2H7a2 2 0 00-2 2v2a2 2 0 002 2h10a2 2 0 002-2v-2a2 2 0 00-2-2zm-3-4h.01M12 11h.01M12 8h.01M12 5h.01"
                    />
                  </svg>
                ),
              },
              {
                title: "Real Estate",
                description:
                  "Data-driven decisions by organizing information from listings, CRMs, market trends, and client interactions—delivering actionable insights for smarter sales, investments, and growth.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                ),
              },
              {
                title: "Healthcare",
                description:
                  "Transform patient care and operational efficiency with secure, AI-powered solutions designed for medical practices. Our platform seamlessly integrates automated insurance claims processing, reducing administrative delays, minimizing errors, and ensuring real-time eligibility verification.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                ),
              },
              {
                title: "Travel",
                description:
                  "Enhance booking experiences and customer service for travel agencies and hospitality businesses.",
                icon: (
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                ),
              },
            ].map((industry, index) => (
              <motion.div
                key={industry.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.15 }}
                whileHover={{ y: -15, scale: 1.03, transition: { duration: 0.3 } }}
                className="backdrop-blur-xl bg-white/15 border-2 border-white/30 p-8 rounded-2xl hover:border-highlight/70 transition-all duration-300 group shadow-xl shadow-highlight/10 hover:shadow-highlight/30"
              >
                <motion.div
                  className="mb-6 text-white group-hover:text-highlight transition-colors duration-300"
                  whileHover={{ rotate: [0, -10, 10, -5, 0], transition: { duration: 0.5 } }}
                >
                  <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br from-accent2 to-highlight border-2 border-white/50 group-hover:border-highlight/50 transition-all duration-300 shadow-lg shadow-highlight/30">
                    {industry.icon}
                  </div>
                </motion.div>
                <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-highlight transition-colors duration-300">
                  {industry.title}
                </h3>
                <p className="text-white group-hover:text-white transition-colors duration-300 font-medium">
                  {industry.description}
                </p>
                <div className="w-0 group-hover:w-full h-1 bg-gradient-to-r from-accent2 to-highlight mt-6 transition-all duration-500 rounded-full"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="py-20 bg-white dark:bg-gray-800">
        <div className="container-custom">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-3xl md:text-4xl font-bold text-dark mb-4"
            >
              What Our Clients Say
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-lg text-gray-600 max-w-3xl mx-auto"
            >
              Hear from businesses that have transformed their operations with our AI solutions
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                quote: "AlfasTech's AI solution has completely transformed how we handle customer inquiries. Response times are down 70% and customer satisfaction is up 45%.",
                name: "Sarah Johnson",
                title: "Customer Service Director, E-commerce Inc.",
                image: "https://randomuser.me/api/portraits/women/32.jpg"
              },
              {
                quote: "Implementing AlfasTech's order management system was seamless. Our team now handles twice the volume with half the staff, and our customers are happier than ever.",
                name: "Michael Chen",
                title: "Operations Manager, TravelRight",
                image: "https://randomuser.me/api/portraits/men/46.jpg"
              },
              {
                quote: "The insights from AlfasTech's analytics platform have been game-changing for our business strategy. We've identified opportunities we never knew existed.",
                name: "Jessica Williams",
                title: "CEO, RetailPlus",
                image: "https://randomuser.me/api/portraits/women/65.jpg"
              }
            ].map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="bg-light p-8 rounded-lg"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
                    <img src={testimonial.image || "/placeholder.svg"} alt={testimonial.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <h4 className="font-bold text-dark">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.title}</p>
                  </div>
                </div>
                <p className="text-gray-600 italic">"{testimonial.quote}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Global Presence Section */}
      <section className="py-32 bg-background relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-accent/5 to-transparent"></div>
        <div className="absolute -top-20 right-20 w-72 h-72 rounded-full bg-accent opacity-5 blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-72 h-72 rounded-full bg-accent2 opacity-5 blur-3xl"></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-bold text-white mb-6 font-futuristic"
            >
              Global{" "}
              <span className="bg-gradient-to-r from-highlight to-accent bg-clip-text text-transparent">Presence</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl text-white max-w-3xl mx-auto mb-20"
            >
              AlfasTech drives innovation with AI consulting, blending data analytics, software engineering, and cloud
              services
            </motion.p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="backdrop-blur-md bg-white/10 border border-white/20 p-8 rounded-2xl"
            >
              <h3 className="text-2xl font-bold mb-6 text-white">Our Global Network</h3>
              <p className="text-lg text-white mb-8">
                With offices and partners across five continents, we deliver AI solutions that transcend geographical
                boundaries and cultural differences.
              </p>
              <div className="mb-8">
                <p className="text-lg mb-6 text-white">Ready to discuss your project?</p>
                <Link
                  to="/contact"
                  className="px-8 py-4 rounded-full font-semibold text-lg bg-gradient-to-r from-accent to-accent2 shadow-lg hover:shadow-accent/50 hover:scale-105 transition-all duration-300 text-white inline-block border-2 border-white/20"
                >
                  Let's Talk
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <div className="relative backdrop-blur-md bg-white/10 border border-white/20 p-6 rounded-2xl overflow-hidden">
                {/* World Map with Dots */}
                <div className="w-full h-80 md:h-96 relative">
                  {/* World Map SVG */}
                  <img src="/world.svg" alt="World Map" className="absolute inset-0 w-full h-full opacity-50" />

                  {/* Office locations */}
                  {[
                    { name: "USA", x: "10%", y: "50%", isMain: true },
                    { name: "Canada", x: "15%", y: "40%", isMain: false },
                    { name: "Saudi Arabia", x: "50%", y: "58%", isMain: true },
                    { name: "Pakistan", x: "61%", y: "52%", isMain: true },
                    { name: "Australia", x: "77%", y: "78%", isMain: true },
                  ].map((location, index) => (
                    <motion.div
                      key={location.name}
                      initial={{ opacity: 0, scale: 0 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.5, delay: 0.5 + index * 0.2 }}
                      className={`absolute flex flex-col items-center z-10`}
                      style={{ left: location.x, top: location.y }}
                    >
                      <div
                        className={`w-4 h-4 rounded-full ${location.isMain ? "bg-gradient-to-r from-accent to-accent2" : "bg-highlight"} mb-1 animate-pulse-slow shadow-lg shadow-accent/30`}
                      ></div>
                      <span className="text-xs font-medium text-white bg-background/80 px-2 py-1 rounded-full backdrop-blur-sm border border-white/20">
                        {location.name}
                      </span>
                    </motion.div>
                  ))}

                  {/* Connection lines */}
                  <svg
                    className="absolute inset-0 w-full h-full z-0 opacity-50"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                  >
                    <motion.path
                      initial={{ pathLength: 0, opacity: 0 }}
                      whileInView={{ pathLength: 1, opacity: 0.5 }}
                      viewport={{ once: true }}
                      transition={{ duration: 2, delay: 1 }}
                      d="M20,40 C40,20 50,60 70,40"
                      stroke="url(#lineGradient)"
                      strokeWidth="0.5"
                      fill="none"
                    />
                    <motion.path
                      initial={{ pathLength: 0, opacity: 0 }}
                      whileInView={{ pathLength: 1, opacity: 0.5 }}
                      viewport={{ once: true }}
                      transition={{ duration: 2, delay: 1.3 }}
                      d="M25,30 C40,50 50,30 60,45"
                      stroke="url(#lineGradient)"
                      strokeWidth="0.5"
                      fill="none"
                    />
                    <motion.path
                      initial={{ pathLength: 0, opacity: 0 }}
                      whileInView={{ pathLength: 1, opacity: 0.5 }}
                      viewport={{ once: true }}
                      transition={{ duration: 2, delay: 1.6 }}
                      d="M70,40 C75,50 80,60 85,70"
                      stroke="url(#lineGradient)"
                      strokeWidth="0.5"
                      fill="none"
                    />
                    <defs>
                      <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#5F72FF" />
                        <stop offset="100%" stopColor="#9F53FF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
